export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salva"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se vedi questo, il modulo non è stato ricevuto (ma non dovresti vedere questo)"])}
}